const r = require.context('../icons', false, /\.vue$/);

export default app => {
  r.keys().forEach(fileName => {
    app.component('icon-' + fileName.slice(2, -4), r(fileName).default);
  });
};
